import { Component, Input, OnInit } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { TranslationService } from 'src/app/services/translation.service';
import { BaseComponent } from '../base/base.component';

@Component({
  selector: 'app-table-options',
  templateUrl: './table-options.component.html',
  styleUrls: ['./table-options.component.scss']
})
export class TableOptionsComponent extends BaseComponent implements OnInit {
  @Input() displayedColumns: any[];

  //Setting the columns label to the option menu
  @Input("optionColumns") set setOptionColumns(optionColumns: any[]) {
    this.initData(optionColumns);
  };

  translationService: TranslationService;
  optionColumns: any[];

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.translationService.userLocaleSubject.subscribe(locale => {
      setTimeout(() => { //Wait for locale to be set.
        this.initData(this.optionColumns);
      }, 0);
    });
  }

  initData(optionColumns: any[]) {
    this.optionColumns = optionColumns;
    optionColumns.forEach(element => {
      let label = element.label();
      element.columnLabel = label;
    });
  }

  //Hide and show the columns
  //Ex: field = {columnCode: "code for each column in the grid", checked: "boolean", label: "function to display the column label"}
  onCheckDisplay(event: MatCheckboxChange, column: any) {
    column.checked = event.checked;

    this.displayedColumns.splice(0, this.displayedColumns.length);
    for (let column of this.optionColumns) {
      if (column.checked) {
        this.displayedColumns.push(column.columnCode);
      }
    }
  }

  hasValue(): boolean {
    for (let optionColumn of this.optionColumns) {
      if (optionColumn.checked) {
        return true;
      }
    }
    return false;
  }

  allSelected(): boolean {
    let numberOfColumns = 0;
    this.optionColumns.forEach(element => {
      if (element.checked) {
        numberOfColumns++;
      }
    });
    return this.optionColumns.length === numberOfColumns;
  }

  masterToggle() {
    if (this.allSelected()) { //when deselecting the main checkbox
      this.clear(this.optionColumns);
    } else { //when selecting the main checkbox
      this.clear(this.optionColumns);//clear all of them first to preserve the order
      this.optionColumns.forEach(element => {
        element.checked = true;
        this.displayedColumns.push(element.columnCode);
      });
    }
  }

  clear(optionColumns: any[]) {
    optionColumns.forEach(element => {
      element.checked = false;
    });
    this.displayedColumns.splice(0, this.displayedColumns.length);
  }
}
